import React from 'react';
import PropTypes from 'prop-types';
import styles from './Sponsors.module.scss';
import classNames from 'classnames';
import isEmpty from '../../utils/isEmpty';
import { useTranslation } from 'next-i18next';

const Sponsors = ({ showEuLogo = false, sponsors = [] }) => {
    const { t } = useTranslation('common');
    if (isEmpty(sponsors) && !showEuLogo) {
        return null;
    }

    return (
        <div className={styles['Sponsors']}>
            <div className={styles['Sponsors__Container']}>
                {<h2 className="sr-only">{t('sponsors.heading')}</h2>}
                <div className={styles['Sponsors__List']}>
                    {showEuLogo && <EuLogo />}
                    {sponsors.map((item, i) => {
                        return <SponsorItem {...item} key={i} />;
                    })}
                </div>
            </div>
        </div>
    );
};

Sponsors.propTypes = {
    showEuLogo: PropTypes.bool,
    sponsors: PropTypes.array,
};

const EuLogo = () => {
    return (
        <div className={styles['Sponsors__ListItem'] + ' ' + styles['Sponsors__ListItem--EuLogo']}>
            <span className="sr-only">European Union Logotype</span>
        </div>
    );
};

EuLogo.propTypes = {};

const SponsorItem = ({ showLogo = false, image = '', href = '', name = '' }) => {
    const maybeLink = (span) => {
        const linkClasses = classNames(styles['Sponsors__Link'], {
            [styles['Sponsors__Link--Text']]: !showLogo || !image,
        });

        if (href) {
            return (
                <a href={href} className={linkClasses} target="_blank" rel="noopener noreferrer">
                    {span}
                </a>
            );
        }

        return span;
    };

    const contentClass = classNames(styles['Sponsors__Name'], {
        'sr-only': showLogo,
    });
    const listItemClasses = classNames(styles['Sponsors__ListItem'], {
        [styles['Sponsors__ListItem--Text']]: !showLogo || !image,
    });

    const customStyles = {
        ...(showLogo && { backgroundImage: `url(${image})` }),
    };

    const content = maybeLink(<span className={contentClass}>{name}</span>);

    return (
        <div className={listItemClasses} style={customStyles}>
            {content}
        </div>
    );
};

SponsorItem.propTypes = {
    showLogo: PropTypes.bool,
    image: PropTypes.string,
    href: PropTypes.string,
    name: PropTypes.string,
};

export default Sponsors;
